import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import { Button } from "~/atoms/button";

interface Props {
  count: number;
  onUnselectAll: () => void;
  disabled?: boolean;
}

export const BulkSelectionBar = ({ count, onUnselectAll, disabled }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex h-6 items-center gap-2">
      {count > 0 && (
        <>
          <span className="text-muted-foreground text-xs">
            {t(($) => $.commons.table.selectedCount, { count })}
          </span>
          <Button
            variant="ghost"
            size="xs"
            disabled={disabled}
            onClick={onUnselectAll}
          >
            <X />
            {t(($) => $.commons.buttons.unselectAll)}
          </Button>
        </>
      )}
    </div>
  );
};
